<template>
  <VCard
    flat
    class="d-flex flex-column justify-center align-center grey lighten-4 fill-height"
    width="100%"
  >
    <span class="subitle-1 text-center mt-4 recording">
      <div class="video-camera">
        <svg
          width="50"
          height="38"
          viewBox="0 0 50 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1.27821"
            y="1.05556"
            width="35.8889"
            height="35.8889"
            rx="7.38889"
            fill="#B24141"
            stroke="#B24141"
            stroke-width="2.11111"
          />
          <path d="M48.7778 7.58187V30.4203C48.7778 30.7912 48.477 31.092 48.1061 31.092L38.0303 25.0465H36.6869C35.203 25.0465 34 23.8436 34 22.3597V15.6425C34 14.1586 35.203 12.9556 36.6869 12.9556H38.0303L48.1061 6.91016C48.477 6.91016 48.7778 7.21089 48.7778 7.58187Z" fill="#B24141" />
          <path
            d="M48.1061 31.092V31.092C48.477 31.092 48.7778 30.7912 48.7778 30.4203V7.58187C48.7778 7.21089 48.477 6.91016 48.1061 6.91016V6.91016M48.1061 31.092V6.91016M48.1061 31.092L38.0303 25.0465M48.1061 6.91016L38.0303 12.9556M38.0303 25.0465V12.9556M38.0303 25.0465H36.6869C35.203 25.0465 34 23.8436 34 22.3597V15.6425C34 14.1586 35.203 12.9556 36.6869 12.9556H38.0303"
            stroke="#B24141"
            stroke-width="2.01515"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div>
        {{ $t('recording') }}
      </div>
    </span>
  </VCard>
</template>

<script>
export default {
  name: 'CandidateInterviewRecording',
};
</script>

<style scoped>
.recording {
  display: inline-block;
  padding: 3.5rem 0 3.875rem;
  color: #B24141;
}

.recording::after {
  content: '';
  display: inline-block;
  position: relative;
  top: -20px;
  float: right;
  width:  4px;
  height: 4px;
  margin: -1px -6px 5px 0px;
  border-radius: 50%;
  background: red;
}

.video-camera {
  margin-bottom: 0.9375rem;
}
</style>

<i18n locale="en" lang="yaml">
  recording: Recording
</i18n>

<i18n locale="ru" lang="yaml">
  recording: Идёт запись
</i18n>
